import getOffset from "../utils/getOffset";
import SetToken from "./formulary/requestToken";
import BuildTable from "./formulary/buildTable";
import FilterTable from "./formulary/filterTable";
import resetFilter from "./formulary/resetFilter";
import GetCBSAData from "./formulary/GetCBSAData";
import GetStateData from "./formulary/GetStateData";
import GetCoverageData from "./formulary/GetCoverageData";
import GetPlansData from "./formulary/GetPlansData";
import GetDerivedFieldData from "./formulary/GetDerivedFieldData";
import GetNotesPAData from "./formulary/GetNotesPAData";
import GetNotesSTData from "./formulary/GetNotesSTData";
import { ShowFormLoading, HideFormLoading, SetShowZipCodeError, ToggleError, updateMonth } from "./formulary/common";
import { API_PARAM } from "./formulary/apiParam";
import "/node_modules/bootstrap/js/modal";

let sortedArray;

class FormularyCoverage {
    constructor() {
        this.formFormulary = document.querySelector("[data-form-formulary]");
        if (!this.formFormulary) return;
        this.resultWrapper = document.querySelector(".CoverageToolResultsWrapper");
        this.productId = this.formFormulary.querySelector('select[name="ProductId"]');
        this.indication = this.formFormulary.querySelector("[data-indication]");
        this.channelId = this.formFormulary.querySelector('select[name="ChannelId"]');
        this.zipCode = this.formFormulary.querySelector('input[name="zipcode"]');
        this.btnSubmit = this.formFormulary.querySelector(".btn-block");
        // Results
        this.coverageToolResults = document.querySelector("#CoverageToolResults");
        this.coverageToolResultsView = document.querySelector(".results__view");
        this.coverageToolResultsTable = document.querySelector("#CoverageToolResultsTable");
        this.coverageToolResultsFilter = this.coverageToolResults.querySelector(".results__view--filter");
        this.coverageToolResultsStatement = this.coverageToolResults.querySelector(".results__statement");
        this.insuranceTypes = this.coverageToolResults.querySelector(".insurance-types");
        this.coverageToolResultsViewShowAll = this.coverageToolResultsView.querySelector(".btn-show-all");
        this.coverageToolClearFilter = document.querySelector(".btn-clear-filter");
        // Coverage Details Modal
        this.coverageDetails = document.querySelector("#modalCoverageDetails");
        this.coverageDetailsTitle = this.coverageDetails.querySelector(".coverage-details__title");
        this.coverageDetailsPlan = this.coverageDetails.querySelector(".coverage-details__plan");
        this.coverageDetailsApiUrl = this.coverageDetails.querySelector(".coverage-details__api-url");
        this.coverageDetailsSubtitle = this.coverageDetails.querySelector(".coverage-details__subtitle");
        this.coverageDetailsCBSA = this.coverageDetails.querySelector(".coverage-details__cbsa");
        this.coverageDetailsIndication = this.coverageDetails.querySelector(".coverage-details__indication");
        this.coverageDetailsBody = this.coverageDetails.querySelector(".coverage-details__body");
        this.coverageDetailsTableDerivedFields = document.querySelector("#CoverageDetailsDerivedFields");
        this.coverageDetailsTableStandardCriteria = document.querySelector("#CoverageDetailsStandardCriteria");
        this.coverageDetailsTableNotesPA = document.querySelector("#CoverageDetailsNotesPA");
        this.coverageDetailsTableNotesST = document.querySelector("#CoverageDetailsNotesST");
        this.coverageDetailsAcronymns = document.querySelector("#acronymnsContainer");
        this.preferedDetailLastChild = document.querySelector("[data-update-date] p:last-child");
        this.init();
    }
    // Render Coverage Results
    onRenderCoverageResults(data) {
        const $this = this;
        const { getCoverage, getPlans, productId, CBSAShortName, channelId, stateId } = data;
        const Coverage = getCoverage;
        const { Plans } = getPlans;

        const insuranceTypes = document.querySelector(".insurance-types");
        const textLabelActive = insuranceTypes.querySelector("label.active").innerText;
        $this.coverageToolResultsStatement.innerHTML = `${textLabelActive} formulary coverage for DUPIXENT in <br class="hidden-xs hidden-sm">the ${CBSAShortName} area`;

        $this.coverageToolResultsView.classList.remove("results__view--show-all");

        let indicationId;
        let indicationName;
        switch ($this.indication.dataset.indication) {
            case "AD":
                indicationId = API_PARAM.atopicDermatitis.indication.id;
                indicationName = API_PARAM.atopicDermatitis.indication.name;
                break;
            case "AS":
                indicationId = API_PARAM.asthma.indication.id;
                indicationName = API_PARAM.asthma.indication.name;
                break;
            case "NP":
                indicationId = API_PARAM.nasalPolyposis.indication.id;
                indicationName = API_PARAM.nasalPolyposis.indication.name;
                break;
            case "EOE":
                indicationId = API_PARAM.eosinophilicEsophagitis.indication.id;
                indicationName = API_PARAM.eosinophilicEsophagitis.indication.name;
                break;
            case "PN":
                indicationId = API_PARAM.prurigoNodularis.indication.id;
                indicationName = API_PARAM.prurigoNodularis.indication.name;
                break;
        }

        const mergedArray = []; // Results
        const _loop = function _loop(_i) {
            const element = Coverage.PlanCoverages[_i]; // Plan
            // let plan = Plans.filter(function (entry) { return entry.ControllerId === element.ControllerId });

            const plan = Plans.filter(entry => entry.PlanId === element.PlanId);
            const planCoverage = Coverage.PlanCoverages.filter(entry => entry.PlanId === element.PlanId); // Covered

            const unifiedTier = element.UnifiedTierId; // let unifiedTier = element.UnifiedTier;
            // Default

            let covered = true;
            const planItem = {}; // Not covered

            if (unifiedTier === 11) {
                covered = false;
            } // Unknown or Not Listed

            if (unifiedTier === 12 || unifiedTier === 13) {
                covered = "unknown";
            }

            planItem.Name = plan[0].Name;
            planItem.Covered = covered;
            planItem.PriorAuthorization = planCoverage[0].PriorAuthorization;
            planItem.StepTherapy = planCoverage[0].StepTherapy;
            planItem.CBSAShortName = CBSAShortName;
            planItem.StateId = stateId;
            planItem.ChannelId = channelId;
            planItem.ProductId = productId;
            planItem.FormularyId = plan[0].FormularyId;
            planItem.IndicationId = indicationId;
            planItem.IndicationName = indicationName;
            mergedArray.push(planItem);
        };

        for (let _i = 0; _i < Coverage.PlanCoverages.length; _i++) {
            _loop(_i);
        }
        // build table
        BuildTable($this.coverageToolResultsView, mergedArray);
        // $this.coverageToolResultsFilterClear.click();
        // $(coverageToolResultsFilterClear).trigger('click');
        sortedArray = mergedArray.sort((x, y) => {
            const a = x.Name.toUpperCase();
            const b = y.Name.toUpperCase();
            return a == b ? 0 : a > b ? 1 : -1;
        });

        document.body.classList.add("results-shown");
    }

    // RequestToAPIsendData
    async onRequestToAPIsendData(data) {
        const $this = this;
        const { productId, channelId, CBSAId, CBSAShortName, stateId } = data;
        const getCoverageAwait = GetCoverageData({ productId, channelId, CBSAId, stateId });
        const getPlansAwait = GetPlansData({ channelId, CBSAId, stateId });
        const getCoverage = await getCoverageAwait;
        const getPlans = await getPlansAwait;

        if (getCoverage && getPlans) {
            $this.onRenderCoverageResults({ getCoverage, getPlans, productId, CBSAId, CBSAShortName, channelId, stateId });
            HideFormLoading($this.resultWrapper);
        } else {
            console.error("error"); // eslint-disable-line
        }
    }
    // ProcessRequestAPI
    async onProcessRequestAPI(elementWrapperResult) {
        const $this = this;
        const productId = $this.productId.value;
        const zipCode = $this.zipCode.value;
        const indicationId = "";
        let channelId = $this.channelId.value;
        let CBSAId;
        let CBSAShortName;
        let stateId;

        if ($this.insuranceTypes && $this.insuranceTypes.querySelector("input:checked")) {
            channelId = $this.insuranceTypes.querySelector("input:checked").value;
        }
        // Get CBSA
        const data = await GetCBSAData(zipCode);
        if (data.CBSA) {
            CBSAId = data.CBSA.CBSAId;
            CBSAShortName = data.CBSA.ShortName;
            $this.onRequestToAPIsendData({ productId, zipCode, indicationId, channelId, CBSAId, CBSAShortName, stateId });
        } else {
            // check Zipcode
            const getState = await GetStateData();
            if (getState) {
                const zipInfo = getState.Zips.filter(o => o.ZipCode === zipCode * 1);
                if (zipInfo.length) {
                    stateId = zipInfo[0].StateId;
                    $this.onRequestToAPIsendData({ productId, zipCode, indicationId, channelId, CBSAId, CBSAShortName, stateId });
                } else {
                    SetShowZipCodeError(true);
                    elementWrapperResult.classList.add("hidden");
                    const statusTool = document.querySelector(".status-tool");
                    if (statusTool) {
                        window.scrollTo({ top: getOffset(statusTool) - 60, behavior: "smooth" });
                    }
                }
            } else {
                ToggleError(true);
            }
        }
    }

    // ----------------------- Detail Modal-----------------------------------

    async onRenderCoverageDetailsModal(data) {
        const $this = this;
        const { plan, CBSAShortName, productId, formularyId, indicationId, indicationName, stateShortName } = data;
        let derivedFieldId;

        const ad = API_PARAM.atopicDermatitis.indication.name;
        const asthma = API_PARAM.asthma.name;
        const np = API_PARAM.nasalPolyposis.name;
        const eoe = API_PARAM.eosinophilicEsophagitis.name;
        if (indicationName === ad) {
            derivedFieldId = API_PARAM.atopicDermatitis.derivedFieldId;
        } else if (indicationName === asthma) {
            derivedFieldId = API_PARAM.asthma.derivedFieldId;
        } else if (indicationName === np) {
            derivedFieldId = API_PARAM.nasalPolyposis.derivedFieldId;
        } else if (indicationName === eoe) {
            derivedFieldId = API_PARAM.eosinophilicEsophagitis.derivedFieldId;
        } else {
            derivedFieldId = API_PARAM.prurigoNodularis.derivedFieldId;
        }

        const getDerivedFieldAwait = GetDerivedFieldData({ productId, formularyId, derivedFieldId });
        const getNotesPAAwait = GetNotesPAData({ productId, formularyId, indicationId });
        const getNotesSTAwait = GetNotesSTData({ productId, formularyId, indicationId });

        const getDerivedField = await getDerivedFieldAwait;
        const getNotesPA = await getNotesPAAwait;
        const getNotesST = await getNotesSTAwait;

        const derivedField = getDerivedField ? getDerivedField.DerivedFields : false;
        const notesPA = getNotesPA ? getNotesPA : false;
        const notesST = getNotesST ? getNotesST : false;

        $this.coverageDetailsPlan.innerHTML = plan;
        $this.coverageDetailsCBSA.innerHTML = CBSAShortName !== "undefined" ? CBSAShortName : stateShortName;
        $this.coverageDetailsIndication.innerHTML = indicationName; // Views

        const tbodyDerivedFields = $this.coverageDetailsTableDerivedFields.querySelector("tbody");
        const tbodyNotesPA = $this.coverageDetailsTableNotesPA.querySelector("tbody");
        const tbodyNotesST = $this.coverageDetailsTableNotesST.querySelector("tbody");
        // Reset tables

        tbodyDerivedFields.innerHTML = "";
        tbodyNotesPA.innerHTML = "";
        tbodyNotesST.innerHTML = "";
        $this.coverageDetailsAcronymns.innerHTML = "";

        const singleErrorMessage = "<tr><td colspan='2'><span class='missing-info'>We're sorry, but the detailed information on this requirement for the plan's coverage is not available. Please contact the patient's health plan to confirm coverage and details.</span></td></tr>";
        const dualErrorMessage = "<tr><td colspan='2'><span class='missing-info'>We're sorry, but the detailed information on the requirements for this plan's coverage are not available. <br class='visible-lg'>Please contact the patient's health plan to confirm coverage and details.</span></td></tr>";

        // START ST
        let stnote = "";
        let panote = "";
        if ((derivedFieldId == 1189 || derivedFieldId == 656) && derivedField) {
            // derived field
            stnote = `<tr><td>${derivedField[0].Value}</td></tr>`;
        } else if (notesST) {
            if (notesST.StructuredNotes[0].Note == null) {
                // 204 no content
                stnote = `<tr><td>We’re sorry, but the detailed information on this requirement 
                for the plan’s coverage is not available. Please contact the patient’s health 
                plan to confirm coverage and details.</td></tr>`;
            } else {
                // full ST
                stnote = `<tr><td>${notesST.StructuredNotes[0].Note}</td></tr>`;
            }
        } else {
            // neither
            stnote = singleErrorMessage;
        }

        tbodyNotesST.insertAdjacentHTML("beforeend", stnote);

        if (stnote.indexOf("TCI") >= 0) $this.coverageDetailsAcronymns.insertAdjacentHTML("beforeend", "<div>TCI = Topical Calcineurin Inhibitor</div>");
        if (stnote.indexOf("TCS") >= 0) $this.coverageDetailsAcronymns.insertAdjacentHTML("beforeend", "<div>TCS = Topical Corticosteroid</div>");
        if (stnote.indexOf("PDE4") >= 0) $this.coverageDetailsAcronymns.insertAdjacentHTML("beforeend", "<div>PDE4 = Phosphodiesterase 4</div>");
        if (stnote.indexOf("LABA") >= 0) $this.coverageDetailsAcronymns.insertAdjacentHTML("beforeend", "<div>LABA = long-acting beta-agonists</div>");
        // END ST

        // START PA
        if (notesPA) {
            for (const key in notesPA) {
                panote = `${panote}<tr><td>${key}</td><td><strong>${notesPA[key]}</strong></td></tr>`;
            }
        } else {
            panote = singleErrorMessage;
        }
        // END PA

        if (derivedField || notesST || notesPA) {
            tbodyNotesPA.insertAdjacentHTML("beforeend", panote);
            $this.coverageDetails.classList.remove("no-reqs");
        } else {
            tbodyNotesST.innerHTML = dualErrorMessage;
            $this.coverageDetails.classList.add("no-reqs");
        }

        HideFormLoading($this.resultWrapper);

        $("#modalCoverageDetails").modal("show");
    }

    onLoadDetailsModal(el) {
        const $this = this;
        const plan = el.getAttribute("data-plan");
        const CBSAShortName = el.getAttribute("data-cbsaShortName");
        const channelId = el.getAttribute("data-channelId");
        const productId = el.getAttribute("data-productId");
        const formularyId = el.getAttribute("data-formularyId");
        const indicationId = el.getAttribute("data-indicationId");
        const indicationName = el.getAttribute("data-indicationName");
        const stateShortName = el.getAttribute("data-stateshort");

        $this.onRenderCoverageDetailsModal({ plan, CBSAShortName, channelId, productId, formularyId, indicationId, indicationName, stateShortName });
    }

    onCoverageToolResultsView() {
        const $this = this;
        $this.coverageToolResultsView.addEventListener("click", function(e) {
            if (!e.target.closest(".trigger-coverage-details")) return;
            e.preventDefault();
            ShowFormLoading($this.resultWrapper);
            $this.onLoadDetailsModal(e.target.closest(".trigger-coverage-details"));
        });
    }
    // -------------- End Details Modal ------------------------

    onProcessForm() {
        const $this = this;
        const IS_ALL_DIGITS_REGEX = /^[0-9]+$/;
        const ZIP_CODE_MAX_LENGTH = 5;
        const zipCodeLength = $this.zipCode.value.length;
        if (zipCodeLength < ZIP_CODE_MAX_LENGTH || !IS_ALL_DIGITS_REGEX.test($this.zipCode.value)) {
            SetShowZipCodeError(true);
            return;
        }
        SetShowZipCodeError(false);

        $this.resultWrapper.classList.remove("hidden");
        // show loading
        ShowFormLoading($this.resultWrapper);
        // scroll to element
        window.scrollTo({ top: getOffset($this.resultWrapper), behavior: "smooth" });
        // Process Form API
        $this.onProcessRequestAPI($this.resultWrapper);
        // reset filter table
        if ($this.coverageToolResultsFilter.value.length) {
            $this.coverageToolResultsFilter.value = "";
            FilterTable($this);
        }
    }
    // Submit Form
    onHandleFormSubmit() {
        const $this = this;
        $this.formFormulary.addEventListener("submit", e => {
            e.preventDefault();
            $this.onProcessForm();
        });
    }

    onClickChangeType() {
        const $this = this;
        const radios = $this.insuranceTypes.querySelectorAll("input[type=radio]");

        Array.prototype.forEach.call(radios, radio => {
            radio.onchange = () => {
                $this.onProcessForm();
            };
        });
    }

    // action filter table
    onHandleFilterTable() {
        const $this = this;
        $this.coverageToolResultsFilter.addEventListener("input", () => {
            FilterTable($this);
        });
    }
    //clear filter
    onHandlerClearFilter() {
        const $this = this;
        $this.coverageToolClearFilter.addEventListener("click", () => {
            resetFilter($this);
        });
    }
    //Show all
    onHandleViewAllTableDetail() {
        const $this = this;
        $this.coverageToolResultsViewShowAll.addEventListener("click", e => {
            e.preventDefault();
            $this.coverageToolResultsView.classList.add("results__view--show-all");
            BuildTable($this.coverageToolResultsView, sortedArray);
        });
    }

    async setToken() {
        await SetToken(this.btnSubmit);
    }

    init() {
        const $this = this;
        $this.setToken();
        $this.onHandleFormSubmit(); //Form Submit
        $this.onClickChangeType();
        $this.onCoverageToolResultsView(); //Show Result in Modal
        $this.onHandleFilterTable();
        $this.onHandleViewAllTableDetail();
        $this.onHandlerClearFilter();

        $this.coverageToolResultsTable.addEventListener("touchstart", () => {
            $this.coverageToolResults.classList.add("table-scrolled");
        });

        updateMonth($this.preferedDetailLastChild);
    }
}

export default FormularyCoverage;
